import { Activity, KeyRound, LayoutDashboard, ScrollText, Wrench } from 'lucide-react';
import { useEffect } from 'react';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useApp } from './stores/app';
import { Dashboard } from './pages/Dashboard';
import { Events } from './pages/Events';
import { Login } from './pages/Login';
import { StreamDetailPage } from './pages/StreamDetail';
import { Streams } from './pages/Streams';
import { Tokens } from './pages/Tokens';
import { Tools } from './pages/Tools';

const NAV = [
  { to: '/', label: 'Дашборд', icon: LayoutDashboard, end: true },
  { to: '/streams', label: 'Потоки', icon: Activity, end: false },
  { to: '/tokens', label: 'Токены', icon: KeyRound, end: false },
  { to: '/tools', label: 'Инструменты', icon: Wrench, end: false },
  { to: '/events', label: 'Логи', icon: ScrollText, end: false },
];

export function App() {
  const { user, ready, init, logout } = useApp();

  useEffect(() => {
    void init();
  }, [init]);

  if (!ready) return <div className="login-wrap muted">Загрузка…</div>;
  if (!user) return <Login />;

  return (
    <div className="layout">
      <nav className="sidebar">
        <div className="brand">
          Рестример
          <small>админка</small>
        </div>
        {NAV.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
        <div style={{ flex: 1 }} />
        <div className="muted" style={{ padding: '0 10px', fontSize: 12 }}>
          {user.login} · {user.role}
        </div>
        <button className="small" onClick={() => void logout()} style={{ margin: '6px 10px' }}>
          Выйти
        </button>
      </nav>

      <main className="content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/streams" element={<Streams />} />
          <Route path="/streams/:key" element={<StreamDetailPage />} />
          <Route path="/tokens" element={<Tokens />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/events" element={<Events />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
